import { render, staticRenderFns } from "./Value.vue?vue&type=template&id=32c4d4df&"
import script from "./Value.vue?vue&type=script&lang=js&"
export * from "./Value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports